<template>
  <div class="work-bench-container" v-bind="$attrs">
    <!-- 底图选择区块 -->
    <div class="work-bench-select-block">
      <WorkBenchSelect @mapChange="mapChange"></WorkBenchSelect>
      <ExportBaseMapButton v-if="selectedMap" :mapItem="selectedMap" />
    </div>
    <!-- 数据面板：组件挂载即请求，接口返回后才可见 -->
    <div class="work-bench-data-panel" v-if="selectedMap" v-show="dataReady">
      <WorkBenchInfoV2 :key="selectedMap.mapId" :mapItem="selectedMap"
        @dataLoaded="dataReady = true"></WorkBenchInfoV2>
    </div>
  </div>
</template>

<script setup>
import {
  onUnmounted,
  ref,
} from 'vue';
import store from '@/store';

import WorkBenchSelect from './WorkBenchSelect';
import WorkBenchInfoV2 from './WorkBenchInfo';
import ExportBaseMapButton from './components/ExportBaseMapButton';

import { addRegionDirectory } from '@/api/RegionDirectoryApi';

const selectedMap = ref();
const dataReady = ref(false);

const mapChange = (mapItem) => {
  dataReady.value = false;
  selectedMap.value = mapItem;
  store.commit('isWorkModeChange', mapItem != undefined);
  store.commit('workBenchMapIdChange', mapItem?.mapId);

  if (mapItem) {
    store.commit('polySubmitPortChange', (data) => {
      return addRegionDirectory({ ...data, mapId: mapItem.mapId });
    });
  } else {
    store.commit('polySubmitPortChange', undefined);
  }
}

onUnmounted(() => {
  store.commit('isWorkModeChange', false);
  store.commit('workBenchMapIdChange', undefined);
  store.commit('polySubmitPortChange', undefined);
});

</script>

<style lang='less'></style>

<style lang='less' scoped>
.work-bench-container {
  position: absolute;
  left: 10px;
  top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 280px;
  z-index: 800;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

/* 底图选择区块 */
.work-bench-select-block {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--backgroundColor_2, rgba(20, 20, 20, 0.65));
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: var(--borderRadiusSize_2);
  padding: 6px 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--borderColor_9);
}

/* 数据面板 */
.work-bench-data-panel {
  background: var(--backgroundColor_2, rgba(20, 20, 20, 0.65));
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: var(--borderRadiusSize_2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--borderColor_9);
  padding: 8px;
  max-height: calc(100vh - 160px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
